<script setup>
import Navi   from "@/components/common/Navi.vue"
import Load   from "@/components/common/Load.vue"
import Appbar from "@/components/common/Header.vue"
import Footer from "@/components/common/Footer.vue"
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
  <v-app>
    <Navi ref="nav" v-if="naviflg == true && load_flg==false" />
    <Appbar v-else />
    <v-main
    >
        <v-card
            min-width="325px"
            class="pb-5"
            flat
            tile
        >
            <router-view @navclose="nav" v-if="load_flg==false"  />
            <Load v-else />
        </v-card>
    </v-main>
    <Footer v-if="load_flg==false" />
  </v-app>
</template>
<script>
export default {
  head: {
    link:
        [
          { rel: 'stylesheet', href: "https://qlipper.jp/css/common_vuetify.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/relcreate.css" },
          { rel: 'stylesheet', href: "https://qlipper.jp/css/vuetify_custom.css" },
          { rel: 'stylesheet', href: "https://cdn.jsdelivr.net/npm/@mdi/font@7.3.67/css/materialdesignicons.min.css" },
        ],
   },
    computed : {
        routpath : function(){
            return this.$route.path;
        },
        device : function(){
            let device_flg;
            if (window.matchMedia("(max-width: 768px)").matches) {
                device_flg = false;
            } else {
                device_flg = true;
            }
            return device_flg;
        },
    },
    watch : {
        routpath : function(){
            if(this.$route.path == '/confirm' || this.$route.path == '/login' || this.$route.path == '/device' )
            {
                this.naviflg  = false;
                this.load_flg = false;
            }
            else
            {
                this.naviflg  = true;
				this.logininfo();
            }
        },
    },
    data    : function(){
        return {
            naviflg : true,
            load_flg : true,
        };
    },
    methods : {
        nav : function (){
            this.$refs.nav.close();
        },
        logininfo : async function(){
            var params = new URLSearchParams();
            await axios.post("/api/session/get_userstatus",params)
            .then(response => {
                if(response.data == null)
                {
                    this.$router.push('/login');
                }
                this.$store.commit("member_info/set_user_kind","会員");
                if(response.data._PAY_FLG=='t')
                    this.$store.commit("member_info/set_pay_flg",true);
                if(response.data._CAL_FLG=='t')
                    this.$store.commit("member_info/set_cal_flg",true);
                this.load_flg = false;
            })
            .catch((error) => {
                console.error('失敗です', error);
            });
        },
    },
    created : function(){
        if(this.$route.path == '/confirm' || this.$route.path == '/login' || this.$route.path == '/signup' || this.$route.path == '/device')
        {
            this.naviflg  = false;
            this.load_flg = false;
            this.$store.commit("member_info/set_user_kind","ゲスト");
        }
        else
        {
            if(this.device==false)
            {
                this.$router.push("/device");
            }
            this.logininfo();
        }
    },
}
</script>
<style>
div{
    line-height: 1.2!important;
}
.v-list-item__title{
    font-size : 1.2rem!important;
}
.v-list-item__content{
    padding : 0!important;
}
.v-list-item{
    min-height : 30px!important;
}
</style>
